// import logger from './utils/logger'
import {
  COMPONENTS_TYPE
} from './utils/constant'
Component({
  options: {
    pureDataPattern: /^_/ // 指定所有 _ 开头的数据字段为纯数据字段
  },
  properties: {
    // 组件类型
    type: {
      type: String,
      value: ''
    },
    // 供应商序列号
    vendorSn: {
      type: String,
      value: ''
    },
    // 供应商密钥
    secret: {
      type: String,
      value: ''
    },
    // 应用appid
    appId: {
      type: String,
      value: ''
    },
    // 用户唯一标识
    openId: {
      type: String,
      value: ''
    },
    // 扫码二维码链接
    qrCodeUrl: {
      type: String,
      value: ''
    },
    // 订单优惠标记，代金券或立减优惠功能的参数
    goodsTag: {
      type: String,
      value: ''
    },
    // 主题颜色
    themeColor: {
      type: String,
      value: '#32A0FA'
    },
    extentInfo: { // 扩展信息字段
      type: Object,
      value: {}
    }
  },
  data: {
    COMPONENTS_TYPE
  },
  observers: {},
  lifetimes: {
    attached () {},
    detached () {},
    error (error) {}
  },
  methods: {
    /**
     * @function 支付组件错误页-点击返回
     * @param {event} e
     */
    handleErrBack (e) {
      this.triggerEvent('errClick', e)
    },
    /**
     * @function 用户取消支付
     * @param {event} e
     */
    handleCancelPay (e) {
      this.triggerEvent('cancelPay', e)
    }
  }
})
